"use strict";

exports.__esModule = true;
exports.Ring = Ring;
exports.Plane = Plane;
exports.Pulse = Pulse;

var _react = _interopRequireDefault(require("react"));

var _Spin = _interopRequireDefault(require("./Spin"));

var _spin = require("../styles/spin");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function formatSize(size) {
  var ss = /^(\d+)([%|\w]*)$/.exec(size);
  return {
    value: parseFloat(ss[1]),
    unit: ss[2] || 'px'
  };
}

function Ring(obj) {
  var _formatSize = formatSize(obj.size),
      value = _formatSize.value,
      unit = _formatSize.unit;

  var style = {
    borderWidth: value / 10 + unit,
    borderTopColor: obj.color
  };
  return _react.default.createElement(_Spin.default, _extends({}, obj, {
    style: style,
    spinClass: _spin.ringClass
  }));
}

function Plane(obj) {
  var style = {
    backgroundColor: obj.color
  };
  return _react.default.createElement(_Spin.default, _extends({}, obj, {
    style: style,
    spinClass: _spin.planeClass
  }));
}

function Pulse(obj) {
  var style = {
    backgroundColor: obj.color
  };
  return _react.default.createElement(_Spin.default, _extends({}, obj, {
    style: style,
    spinClass: _spin.pulseClass
  }));
}